// Mock plans matching backend/skills/plan_schema.py::WeeklyPlanV2.
// Use these to render the UI before wiring the /weekly-plan/generate-v2 API.
// Keep keys identical to the Pydantic schema — the renderer is keyed
// directly off these names.

export const MOCK_RUNNING_PLAN = {
  week_start: '2026-05-24',
  week_end: '2026-05-30',
  sport_type: 'running',
  phase: 'build',
  phase_label: 'בנייה (Build)',
  total_km: 70,
  estimated_duration_minutes: 425,
  context: {
    days_until_goal: null,
    is_taper: false,
    goal_race: null,
    tune_up_races: [
      { name: 'הרצליה', date: '2026-06-12', distance: '10K' },
    ],
  },
  intro:
    'שבוע בנייה עם נפח גבוה הכולל שני אימונים ארוכים של 28 ק"מ ויום אינטרוולים מרוכז. ' +
    'בין האימונים — ימי מנוחה מלאים. המטרה: בניית בסיס אירובי חזק וחיזוק יעילות ריצה לקראת המרוץ ב-12/06.',
  load_warning:
    'זהו שבוע נפח גבוה במיוחד הכולל שני אימונים של 28+ ק"מ. הקפד על התאוששות מלאה — שינה 7-9 שעות, הידרציה רציפה ופחמימות בארוחות.',
  tips_summary: [
    'שתה לפחות 3 ליטר מים ביום, יותר בימי האימונים הארוכים',
    'שינה איכותית של 7-9 שעות בלילה היא חלק מהאימון',
    'פחמימות איכותיות 2-3 שעות לפני האימונים הארוכים',
    'גלגל קצף 10 דקות בכל יום מנוחה — שוקיים והאמסטרינג',
  ],
  gear_notes:
    'נעלי אימון רגילות לאורך השבוע. וסט מים או חגורת הידרציה לריצות ה-28 ק"מ. נעל קלה ורספונסיבית לטמפו.',
  days: [
    {
      day_name: 'ראשון',
      date: '2026-05-24',
      is_rest: false,
      type: 'טמפו',
      icon: '🎯',
      km: 14,
      duration_min: 80,
      pace: { min: '5:46', max: '5:56', label: 'טמפו' },
      structure: [
        { segment: 'חימום', km: 2, pace: { min: '6:10', max: '6:30', label: 'קל' } },
        { segment: 'טמפו רצוף', km: 10, pace: { min: '5:46', max: '5:56', label: 'סף לקטי' } },
        { segment: 'שחרור', km: 2, pace: { min: '6:10', max: '6:30', label: 'קל' } },
      ],
      description:
        'אימון איכות מרכזי של השבוע. שמור על קצב אחיד לאורך כל 10 הק"מ — אל תצא מהיר מדי בקילומטר הראשון.',
      tips: [
        'נשימה עמוקה ויציבה — לא להתנשף',
        'אם הקצב מרגיש קשה מדי בק"מ 6 — האט ב-5 שניות, אל תילחם בזה',
      ],
      target_zone: 'Threshold',
      rpe_effort: 7,
      coach_notes:
        'הטמפו הוא הלב של השבוע. עדיף לסיים בעקביות מאשר לדחוף יתר על המידה. אם הרגליים עייפות מאתמול — האט.',
      gear_notes: 'נעל קלה ורספונסיבית. בקבוק מים בנקודת ההתחלה.',
    },
    {
      day_name: 'שני',
      date: '2026-05-25',
      is_rest: true,
      rest_type: 'active',
      description:
        'מנוחה פעילה — 20-30 דקות הליכה קלה + 10 דקות גלגל קצף לתאומים והאמסטרינג. הידרציה ושינה איכותית.',
      gear_notes: 'גלגל קצף, נעלי הליכה נוחות.',
    },
    {
      day_name: 'שלישי',
      date: '2026-05-26',
      is_rest: false,
      type: 'ריצה ארוכה',
      icon: '🏃',
      km: 28,
      duration_min: 175,
      pace: { min: '6:10', max: '6:30', label: 'Zone 2' },
      structure: [],
      description:
        'הריצה הארוכה הראשונה של השבוע. קצב אחיד לאורך כל המרחק. ללא עלייה בקצב בחלק האחרון.',
      tips: [
        'הידרציה מהקילומטר ה-10',
        'ג\'ל אנרגיה אחד באמצע הריצה',
        'חלק את המסלול ל-3 פלחים של ~9-10 ק"מ',
      ],
      target_zone: 'Zone 2',
      rpe_effort: 5,
      coach_notes:
        'אם הרגליים עייפות מהטמפו של אתמול — האט בעוד 10-15 שניות, אל תילחם.',
      gear_notes: 'וסט מים או חגורת הידרציה.',
    },
    {
      day_name: 'רביעי',
      date: '2026-05-27',
      is_rest: true,
      rest_type: 'active',
      description: 'התמקד בהתאוששות לקראת חמישי. שחייה קלה / יוגה / מתיחות סטטיות.',
    },
    {
      day_name: 'חמישי',
      date: '2026-05-28',
      is_rest: false,
      type: 'ריצה ארוכה',
      icon: '🏔️',
      km: 28,
      duration_min: 170,
      pace: { min: '6:10', max: '6:30', label: 'Zone 2' },
      structure: [],
      description: 'הריצה הארוכה השנייה. אותו עיקרון — נפח, לא מהירות.',
      tips: [
        'אם יש כבדות מצטברת — סיום מוקדם תמיד עדיף',
        'תזונה עם פחמימות 2-3 שעות לפני היציאה',
      ],
      target_zone: 'Zone 2',
      rpe_effort: 5,
      coach_notes:
        'הריצה השנייה ב-3 ימים. הקצב יכול להיראות קל אבל המאמץ הסביל גבוה יותר. כבד את התחושה.',
      gear_notes: 'וסט מים חובה. כובע אם חם.',
    },
    {
      day_name: 'שישי',
      date: '2026-05-29',
      is_rest: true,
      rest_type: 'full',
      description: 'מנוחה מלאה. שינה מספקת + תזונה עשירה בפחמימות וחלבונים.',
    },
    {
      day_name: 'שבת',
      date: '2026-05-30',
      is_rest: true,
      rest_type: 'active',
      description: 'הליכה נינוחה 30 דקות + מתיחות. סכם את השבוע בראש.',
    },
  ],
};

export const MOCK_CYCLING_PLAN = {
  week_start: '2026-05-24',
  week_end: '2026-05-30',
  sport_type: 'cycling',
  phase: 'build',
  phase_label: 'בנייה (Build)',
  total_km: 220,
  estimated_duration_minutes: 480,
  context: {
    days_until_goal: null,
    is_taper: false,
    goal_race: null,
    tune_up_races: [],
  },
  intro:
    'שבוע בנייה ברכיבה — 3 רכיבות עם דגש על הספקים יציבים ועלייה הדרגתית בעומס Sweet Spot.',
  load_warning: null,
  tips_summary: [
    'בדוק לחץ אוויר בצמיגים לפני כל יציאה',
    'אכול פחמימות כל 45 דקות ברכיבות מעל שעתיים',
  ],
  gear_notes: 'אופניי כביש. וסט גשם בתיק אם תחזית גשם.',
  days: [
    {
      day_name: 'ראשון',
      date: '2026-05-24',
      is_rest: false,
      type: 'Sweet Spot',
      icon: '⚡',
      km: 60,
      duration_min: 135,
      pace: { min: '0:00', max: '0:00', label: 'FTP 88-94%' },
      structure: [],
      description: 'אינטרוולי Sweet Spot — 3×15 דקות ב-88-94% FTP עם 5 דקות מנוחה.',
      tips: ['חימום 15 דקות לפני האינטרוול הראשון'],
      target_zone: 'Threshold',
      rpe_effort: 7,
      coach_notes: 'אם ההספק נופל ב-15 דקה השלישית — האט מעט באינטרוול הרביעי.',
      gear_notes: 'מד הספק, חגורת הידרציה.',
    },
    {
      day_name: 'שני',
      date: '2026-05-25',
      is_rest: true,
      rest_type: 'full',
      description: 'מנוחה מלאה.',
    },
    {
      day_name: 'שלישי',
      date: '2026-05-26',
      is_rest: false,
      type: 'אנדורנס',
      icon: '🚴',
      km: 80,
      duration_min: 180,
      pace: { min: '0:00', max: '0:00', label: 'FTP 65-75%' },
      structure: [],
      description: 'רכיבת אנדורנס יציבה ב-Zone 2. שמור על קדנס 85-95.',
      tips: ['פחמימות כל 45 דקות'],
      target_zone: 'Zone 2',
      rpe_effort: 4,
      coach_notes: 'יציבות חשובה מהיר. אל תרדוף קליפים.',
      gear_notes: 'בקבוקים מלאים. ג\'לים 3-4.',
    },
    {
      day_name: 'רביעי',
      date: '2026-05-27',
      is_rest: true,
      rest_type: 'active',
      description: 'הליכה / יוגה. מנוחה מהאוכף.',
    },
    {
      day_name: 'חמישי',
      date: '2026-05-28',
      is_rest: false,
      type: 'אנדורנס',
      icon: '🚴‍♂️',
      km: 80,
      duration_min: 165,
      pace: { min: '0:00', max: '0:00', label: 'FTP 65-75%' },
      structure: [],
      description: 'רכיבה ארוכה שנייה.',
      tips: [],
      target_zone: 'Zone 2',
      rpe_effort: 4,
      coach_notes: 'התמקד בקדנס יציב — 85-95.',
    },
    {
      day_name: 'שישי',
      date: '2026-05-29',
      is_rest: true,
      rest_type: 'full',
      description: 'מנוחה מלאה.',
    },
    {
      day_name: 'שבת',
      date: '2026-05-30',
      is_rest: true,
      rest_type: 'active',
      description: 'הליכה קצרה.',
    },
  ],
};
